import { render } from "./personrecorddetail.vue?vue&type=template&id=2bb9ca83&scoped=true&ts=true"
import script from "./personrecorddetail.vue?vue&type=script&lang=ts"
export * from "./personrecorddetail.vue?vue&type=script&lang=ts"

import "./personrecorddetail.vue?vue&type=style&index=0&id=2bb9ca83&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb9ca83"]])

export default __exports__